export enum RegisterName {
    Connection = "connection",
    UserRegisterEvent = "UserRegister",
    UserDisconnectEvent = "UserDisconnect",
    UserEmitDetected = "UserEmitDetected",
    RegisteredUserSocketId = 'RegisteredUserSocketId',
    ClearExpiredSockets = "ClearExpiredSockets",
    BuisnessRegisterEvent = "BuisnessRegister",
    BuisnessDisconnectEvent = "BuisnessDisconnect",
    RegisteredBusinessSocketId = 'RegisteredBusinessSocketId',
    BusinessEmitDetected = "BusinessEmitDetected"
}

export enum EmitType {
    UserLogged = 1,
    BillingStatusUpdated,
    BillingAmountPaid,
    BillingAction,
    ForceLogout,
    ResetToken,
    UserSystemDataChanged,
    BusinessSystemDataChanged,
    BillBrnUpdated,
    BusinessUpdated,
    BusinessAssignedOrRemoved,
    AttachedTableBill,
    DetachedTableBill,
    RefreshBusiness,
    PaymentProccesed,
    QrTypeUpdated,
    RefreshLiveTokens,
    EmitPrint,
    DeviceSettingsChanged
}